import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";

const queryKeys = {
  get: (payload: IGetSignature) => ["signatureService.get", payload],
};

export interface IGetSignature {
  OwnerId: string;
  ownerKind: number;
  attachmentId: string;
}

const getSignature = (payload: IGetSignature) => {
  const query = new URLSearchParams("");

  query.append("OwnerId", payload.OwnerId);
  query.append("ownerKind", payload.ownerKind.toString());
  query.append("OwnerAttachmentId", payload.attachmentId);

  return axiosInstance.get(`/signature/report?${query}`);
};

const useGetSignature = (payload: IGetSignature, enabled: boolean) => {
  return useCustomQuery(queryKeys.get(payload), () => getSignature(payload), {
    enabled: enabled,
  });
};

export interface IUploadSignature {
  Json: string;
  OwnerAttachmentId: string;
  OwnerId: string;
  OwnerKind: number;
}

const uploadSignature = (payload: IUploadSignature) => {
  return axiosInstance.post("/signature/report", payload);
};

const useUploadSignature = () => {
  return useCustomMutation(uploadSignature);
};

export default {
  useGetSignature,
  useUploadSignature,
};
